import { MINUTE } from '@/constants/unit'
import { getWebSocketUrl } from '@/lib/env'
import { store } from '@/redux'
import { setToken } from '@/redux/global-actions'
import {
  Notification as NotificationType,
  notificationSlice,
} from '@/redux/notification'
import { startAppListening } from '@/redux/utils'

enum WebsocketEventType {
  Notification = 'Notification',
}

type WebsocketEvent = {
  type: WebsocketEventType
  data: NotificationType | Record<string, unknown>
}

const isNotificationEvent = (type: WebsocketEventType, data: WebsocketEvent['data']): data is NotificationType => {
  return type === WebsocketEventType.Notification
}

let webSocket: WebSocket | null = null
let pingInterval: NodeJS.Timeout | null = null

const connectWebSocket = (token: string) => {
  if (webSocket) {
    webSocket.close()
  }
  console.log('connect')
  webSocket = new WebSocket(`${getWebSocketUrl()}?token=${token}`)
  webSocket.addEventListener('open', () => {
    if (pingInterval) {
      clearInterval(pingInterval)
    }
    pingInterval = setInterval(() => {
      webSocket?.send('ping')
    }, MINUTE)
  })
  webSocket.addEventListener('message', ({ data }: MessageEvent<string>) => {
    if (data === 'pong') {
      return
    }
    const { type, data: messageData } = JSON.parse(data) as WebsocketEvent
    if (isNotificationEvent(type, messageData)) {
      store.dispatch(notificationSlice.util.updateQueryData('readAllNotifications', undefined, (draft) => {
        const newNotification = { ...messageData, createdAt: new Date().getTime() }
        if (draft.pages && draft.pages.length > 0) {
          draft.pages[0].rows.unshift(newNotification)
          draft.pages.forEach((page) => {
            page.total += 1
            page.unreadCount += 1
          })
          draft.pageParams.forEach((pageParam) => {
            pageParam.offset += 1
          })
        } else {
          draft.pages = [{
            total: 1,
            rows: [newNotification],
            unreadCount: 1,
          }]
          draft.pageParams = [{
            offset: 1,
            limit: 1,
          }]
        }
      }))
    }
  })
  webSocket.addEventListener('error', (event) => {
    console.log('error', event)
  })
  webSocket.addEventListener('close', (event) => {
    console.log('close', event)
  })
}

startAppListening({
  actionCreator: setToken,
  effect: ({ payload }) => {
    if (payload) {
      connectWebSocket(payload)
    }
  },
})
